<template>
  <div>
    <v-alert v-if="!is_bind" color="primary" type="info" border="left" text prominent>
      <v-row align="center">
        <v-col class="grow"> 尚未綁定 Line OA，無法透過Line通知 </v-col>
        <v-col class="shrink">
          <v-btn color="primary" @click="goBind"> 點我設定 </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-alert v-else text prominent color="green" type="success" border="left">
      <div></div>
      <v-row align="center">
        <v-col class="grow"> 已綁定 Line OA 通知，異常將會透過Line通知 </v-col>
        <v-col class="shrink">
          <v-btn color="green" @click="goBind"> 查看設定 </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-card class="mb-3">
      <v-card-title class="text_primary">
        登入記錄
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-card-subtitle class="pl-0 ml-0 pt-0 mt-0"> 最近24小時內資料。 </v-card-subtitle>

        <v-data-table :headers="headers" :items="items" hide-default-footer></v-data-table>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title class="text_primary">
        通知

        <v-spacer></v-spacer>

        <v-btn v-if="!is_edit" class="text_default btn_default btn_default_bg_linear" outlined @click="startEdit">
          編輯
        </v-btn>

        <v-btn v-if="is_edit" class="text_default btn_default btn_default_bg_linear mr-3" outlined @click="cancelEdit">
          取消
        </v-btn>

        <v-btn v-if="is_edit" class="btn-primary" outlined @click="saveEdit"> 保存 </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="mb-2">
          <div class="red--text subtitle-2">通知規則:</div>
          <div>
            登入數 - 成功數 &gt; 臨界值(<span class="red--text">{{ setting.threshold }}</span
            >) 以及 成功數 / 登入數 &lt; <span class="red--text">{{ setting.percent }}</span
            >%
          </div>
        </div>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <div>
                <h5>臨界值</h5>
                <v-text-field
                  v-model="setting.threshold"
                  outlined
                  dense
                  type="number"
                  :disabled="!is_edit"
                  :rules="[$utils.field_rules.required]"
                >
                </v-text-field>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div>
                <h5 class="mb-4">臨界百分比</h5>
                <v-slider
                  v-model="setting.percent"
                  dense
                  max="100"
                  min="1"
                  step="1"
                  thumb-label="always"
                  :readonly="!is_edit"
                  :color="slider_color"
                  :track-color="slider_track_color"
                >
                </v-slider>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { apiGetThreshold, apiUpdateThreshold, apiGetLoginRecord, apiCreateThreshold } from '@/api/container.js'

import { apiGetContainer } from '@/api/optimize.js'

export default {
  name: 'DetectLogin',
  data() {
    return {
      is_edit: false,
      setting: {},
      copy_setting: {},
      slider_color: 'grey',
      slider_track_color: 'grey',
      headers: [
        { text: '方式', value: 'category', sortable: false },
        { text: '成功數 / 登入數', value: 'detail', sortable: false },
      ],
      items: [],
      login_types: ['facebook', 'line'],
      is_bind: false,
    }
  },
  watch: {
    is_edit(new_val) {
      if (new_val) {
        this.slider_color = 'primary'
        this.slider_track_color = 'primary'
      } else {
        this.slider_color = 'grey'
        this.slider_track_color = 'grey'
      }
    },
  },
  created: async function () {
    await this.getData()
  },
  mounted: function () {},
  methods: {
    async getData() {
      let is_init = false

      try {
        let result = await apiGetContainer(this.$route.params.org_id, this.$route.params.container_id)
        let data = result.data
        if (data.notify_infos) {
          this.is_bind = true
        }
      } catch (error) {
        console.log('error', error)
        if (error.includes('401') || error.includes('403')) {
          this.$root.vtoast.show({
            message: `沒有權限使用此功能，原因: ${error}`,
          })
          this.$router.push(`/${this.$route.params.org_id}/401`)
        } else {
          this.$root.vtoast.show({
            message: `取得容器資料失敗，原因: ${error}`,
          })
        }
      }

      try {
        let result = await apiGetThreshold(this.$route.params.org_id, this.$route.params.container_id)
        let data = result.data
        this.setting = data
        this.setting.percent = this.setting.percent * 100
        this.copy_setting = JSON.parse(JSON.stringify(this.setting))
        console.log(data)
      } catch (error) {
        console.log('error', error)

        if (error.includes('404')) {
          await this.initSetting()
          is_init = true
        } else if (error.includes('401') || error.includes('403')) {
          that.$root.vtoast.show({
            message: `沒有權限使用此功能，原因: ${error}`,
          })
          that.$router.push(`/${that.$route.params.org_id}/401`)
        } else {
          this.$root.vtoast.show({
            message: `取得規則失敗，原因: ${error}`,
          })
        }
      }

      if (is_init) {
        try {
          let result = await apiGetThreshold(this.$route.params.org_id, this.$route.params.container_id)
          let data = result.data
          this.setting = data
          this.setting.percent = this.setting.percent * 100
          this.copy_setting = JSON.parse(JSON.stringify(this.setting))
          console.log(data)
        } catch (error) {
          console.log('error', error)
          this.$root.vtoast.show({
            message: `取得規則失敗，原因: ${error}`,
          })
        }
      }

      let login_record = {}
      try {
        let result = await apiGetLoginRecord(this.$route.params.org_id, this.$route.params.container_id)
        let data = result.data
        if (data) {
          login_record = data.containerRes[this.$route.params.container_id]
          console.log(login_record)
        }
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `取得記錄失敗，原因: ${error}`,
        })
      }
      let that = this
      this.login_types.forEach(function (login_type) {
        let tmp_type = login_type[0].toUpperCase() + login_type.slice(1)
        let tmp_item = {
          category: tmp_type,
        }
        if (login_record[login_type]) {
          tmp_item['detail'] = `${login_record[login_type].success} / ${login_record[login_type].login}`
        } else {
          tmp_item['detail'] = ' 0 / 0'
        }

        that.items.push(tmp_item)
      })
    },
    async initSetting() {
      try {
        let result = await apiCreateThreshold(this.$route.params.org_id, {
          threshold: 30,
          percent: 0.1,
          container_id: this.$route.params.container_id,
        })
        console.log('init_result:', result)
      } catch (error) {
        console.log('error', error)
        this.$root.vtoast.show({
          message: `初始化設定失敗，原因 ${error}`,
        })
      }
    },
    startEdit() {
      this.copy_setting = JSON.parse(JSON.stringify(this.setting))
      this.is_edit = true
    },
    cancelEdit() {
      this.is_edit = false
      this.setting = JSON.parse(JSON.stringify(this.copy_setting))
    },
    async saveEdit() {
      this.is_edit = false
      console.log('setting', this.setting)
      console.log(apiUpdateThreshold)
      let message = ''
      let color = ''
      let params = JSON.parse(JSON.stringify(this.setting))
      params.percent = params.percent / 100
      try {
        let result = await apiUpdateThreshold(this.$route.params.org_id, this.$route.params.container_id, params)
        console.log('result', result)
        message = '規則更新成功！'
        color = 'primary'
      } catch (error) {
        message += '規則更新失敗，原因: '
        if (error.response) {
          message += error.response.data.msg
        } else {
          message += error
        }
      }
      this.$root.vtoast.show({
        message: message,
        color: color,
      })
    },
    goBind() {
      let to = `/${this.$route.params.org_id}/setting/containers/${this.$route.params.container_id}/edit`
      this.$router.push(to)
    },
  },
}
</script>
